<template>
  <div>
    <PageAllow controller="Payment" action="getPaySettings" />
    <Breadcrumbs :items="items" />
    <v-sheet class="transparent-background-color">
      <v-card class="page-card">
        <v-card-title class="mx-3">
          {{ $t("Payment.LCSWCBKPay.title") }}
          <v-spacer></v-spacer>
        </v-card-title>
        <v-progress-linear :indeterminate="loading"></v-progress-linear>
        <v-card-text>
          <ValidationObserver ref="observer">
            <v-container>
              <!-- lcsw_cbk_url -->
              <v-row class="mt-5">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("Payment.LCSWCBKPay.lcsw_cbk_url") + $t("Global.colon") }}
                  <span class="red--text">*</span>
                </v-col>
                <v-col cols="9" md="7">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('Payment.LCSWCBKPay.lcsw_cbk_url')"
                    rules="required"
                  >
                    <v-textarea
                      v-model="lcswcbkSettings.lcsw_cbk_url"
                      outlined
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'lcsw_cbk_url')
                          .concat(errors)
                      "
                    >
                    </v-textarea>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <!-- lcsw_cbk_inst_no -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("Payment.LCSWCBKPay.lcsw_cbk_inst_no") + $t("Global.colon")
                  }}
                  <span class="red--text">*</span>
                </v-col>
                <v-col cols="9" md="7">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('Payment.LCSWCBKPay.lcsw_cbk_inst_no')"
                    rules="required"
                  >
                    <v-text-field
                      v-model="lcswcbkSettings.lcsw_cbk_inst_no"
                      single-line
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'lcsw_cbk_inst_no')
                          .concat(errors)
                      "
                    >
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>

              <!-- lcsw_cbk_brand_no -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("Payment.LCSWCBKPay.lcsw_cbk_brand_no") + $t("Global.colon")
                  }}
                  <span class="red--text">*</span>
                </v-col>
                <v-col cols="9" md="7">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('Payment.LCSWCBKPay.lcsw_cbk_brand_no')"
                    rules="required"
                  >
                    <v-text-field
                      v-model="lcswcbkSettings.lcsw_cbk_brand_no"
                      single-line
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'lcsw_cbk_brand_no')
                          .concat(errors)
                      "
                    >
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>

              <!-- lcsw_cbk_in_account_no -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("Payment.LCSWCBKPay.lcsw_cbk_in_account_no") + $t("Global.colon")
                  }}
                  <span class="red--text">*</span>
                </v-col>
                <v-col cols="9" md="7">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('Payment.LCSWCBKPay.lcsw_cbk_in_account_no')"
                    rules="required"
                  >
                    <v-text-field
                      v-model="lcswcbkSettings.lcsw_cbk_in_account_no"
                      single-line
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'lcsw_cbk_in_account_no')
                          .concat(errors)
                      "
                    >
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <!-- lcsw_cbk_access_token -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("Payment.LCSWCBKPay.lcsw_cbk_access_token") + $t("Global.colon")
                  }}
                  <span class="red--text">*</span>
                </v-col>
                <v-col cols="9" md="7">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('Payment.LCSWCBKPay.lcsw_cbk_access_token')"
                    rules="required"
                  >
                    <v-text-field
                      v-model="lcswcbkSettings.lcsw_cbk_access_token"
                      single-line
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'lcsw_cbk_access_token')
                          .concat(errors)
                      "
                    >
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <!-- lcsw_recharge_account_name -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("Payment.LCSWCBKPay.lcsw_recharge_account_name") + $t("Global.colon")
                  }}
                  <span class="red--text">*</span>
                </v-col>
                <v-col cols="9" md="7">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('Payment.LCSWCBKPay.lcsw_recharge_account_name')"
                    rules="required"
                  >
                    <v-text-field
                      v-model="lcswcbkSettings.lcsw_recharge_account_name"
                      single-line
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'lcsw_recharge_account_name')
                          .concat(errors)
                      "
                    >
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <!-- lcsw_recharge_account_name -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("Payment.LCSWCBKPay.lcsw_recharge_bank_no") + $t("Global.colon")
                  }}
                  <span class="red--text">*</span>
                </v-col>
                <v-col cols="9" md="7">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('Payment.LCSWCBKPay.lcsw_recharge_bank_no')"
                    rules="required"
                  >
                    <v-text-field
                      v-model="lcswcbkSettings.lcsw_recharge_bank_no"
                      single-line
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'lcsw_recharge_bank_no')
                          .concat(errors)
                      "
                    >
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <!-- lcsw_recharge_bank_name -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("Payment.LCSWCBKPay.lcsw_recharge_bank_name") + $t("Global.colon")
                  }}
                  <span class="red--text">*</span>
                </v-col>
                <v-col cols="9" md="7">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('Payment.LCSWCBKPay.lcsw_recharge_bank_name')"
                    rules="required"
                  >
                    <v-text-field
                      v-model="lcswcbkSettings.lcsw_recharge_bank_name"
                      single-line
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'lcsw_recharge_bank_name')
                          .concat(errors)
                      "
                    >
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <!-- lcswpay_cbk_enable -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("Payment.LCSWCBKPay.lcswpay_cbk_enable") + $t("Global.colon")
                  }}
                  <span class="red--text">*</span>
                </v-col>
                <v-col cols="9" md="7">
                  <v-radio-group row v-model="lcswcbkSettings.lcswpay_cbk_enable">
                    <v-radio :label="$t('Payment.off')" key="0" value="0" />
                    <v-radio :label="$t('Payment.on')" key="1" value="1" />
                  </v-radio-group>
                </v-col>
              </v-row>
            </v-container>
          </ValidationObserver>
        </v-card-text>
      </v-card>
      <v-card class="page-opts">
        <v-card-title>
          <v-row dense>
            <v-col cols="12">
              <v-btn
                color="success"
                block
                @click="
                  lcswcbkSettings.lcswpay_cbk_enable == 1
                    ? (alertDialog = true)
                    : save()
                "
              >
                <v-icon small class="pe-1">fa-save</v-icon>
                {{ $t("Payment.save") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
      </v-card>
    </v-sheet>

    <DialogAlert
      v-model="alertDialog"
      :message="$t('Payment.change_wechat_pay', [$t('Payment.lcswcbkpay')])"
      useConfirm
      @confirm="save()"
    />
  </div>
</template>

<script>
import Payment from "@/api/payment";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import DialogAlert from "@/components/plugins/DialogAlert";
import { mapState } from "vuex";
import { ValidationObserver, ValidationProvider } from "vee-validate";

export default {
  data: () => ({
    lcswcbkSettings: {},
    serverErrors: [],
    alertDialog: false,
  }),

  components: {
    PageAllow,
    Breadcrumbs,
    DialogAlert,
    ValidationObserver,
    ValidationProvider,
  },

  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.fundManagement"),
        disabled: false,
        href: "/receipts",
      },
      {
        text: i18n.t("Nav.payment"),
        disabled: true,
        href: "/payment",
      },
    ],
    ...mapState(["loading", "settings"]),
  },

  mounted() {
    this.getAlipayFromAPI();
  },

  methods: {
    getAlipayFromAPI() {
      Payment.fetch({
        keys: [
          "lcsw_cbk_url",
          "lcsw_cbk_inst_no",
          "lcsw_cbk_brand_no",
          "lcsw_cbk_in_account_no",
          "lcsw_cbk_access_token",
          "lcsw_recharge_account_name",
          "lcsw_recharge_bank_no",
          "lcsw_recharge_bank_name",
          "lcswpay_cbk_enable",
        ],
        parse: 0,
      }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.lcswcbkSettings = response.data.settings;

            if (
              this.lcswcbkSettings.lcswpay_cbk_enable == null ||
              typeof this.lcswcbkSettings.lcswpay_cbk_enable == "undefined" ||
              this.lcswcbkSettings.lcswpay_cbk_enable == undefined
            ) {
              this.lcswcbkSettings.lcswpay_cbk_enable = "0";
            }
          }
        }.bind(this)
      );
    },

    save() {
      this.$refs.observer.validate().then(
        function (result) {
          if (result) {
            Payment.LCSWCBKPaySave(this.lcswcbkSettings).then(
              function (response) {
                if (response.data.status.isOK()) {
                  this.$router.push("/payment");
                }
              }.bind(this)
            );
          }
        }.bind(this)
      );
    },
  },

  watch: {},
};
</script>